'use client'

import { useMutation } from "@tanstack/react-query"
import { createCheckout, getCustomerPortalLink } from "../requests/stripe"
import { API_Data_CreateCheckout_Response, API_Data_Customer_Portal_Link_Response } from "@/interfaces/api/stripe/api_response_types"
import { API_Error } from "@/interfaces/api/response/api_response_types"
import { CreateCheckoutData, CustomerPortalLinkData } from "@/interfaces/api/stripe/api_request_types"

export const useCreateCheckout = (discountCode?: string) => useMutation<API_Data_CreateCheckout_Response, API_Error, CreateCheckoutData>({
  retry: false,
  mutationFn: (payload) => createCheckout({
    ...payload,
    discount_code: payload.discount_code ?? discountCode
  })
})